<template>
    <div class="custom-multiselect"
        :class="[customClass, isDropdownOpen && !showSelectionCountGlyphs ? 'greyBack' : '']"
        ref="dropdownContainer">
        <div class="selected-values" @click="toggleDropdown" :data-qa-id="`${insideName} selectedValues`">
            <div class="labelCircle" :data-qa-id="`${insideName} labelCircle`">
                <MdTypography tag="span" :variant="'body2--medium'" :color="'spirits--900'" :data-qa-id="`${insideName} labelText`">{{ labelText }}</MdTypography>
                <MdTypography v-if="selectedItems.length > 0 && selectedItems.length <= 9 && showSelectionCountGlyphs" tag="span" :variant="'body1--regular'" color="blue-duck--500" v-html="NUMBER_CIRCLE_GLYPH[selectedItems.length]"></MdTypography>
                <span v-if="selectedItems.length > 9 && showSelectionCountGlyphs" class="circle" :data-qa-id="`${insideName} circle`">{{ selectedItems.length }}</span>
            </div>
            <span class="dropdownArrow" :data-qa-id="`${insideName} drodownArrow`">
                <MdIconArrowCaret :rotate="isDropdownOpen ? 'up' : 'down'" :color="isDropdownOpen ? 'spirits--900' : 'spirits--600'" :data-qa-id="`${insideName} caret`"></MdIconArrowCaret>
            </span>
        </div>
        <div v-if="isDropdownOpen" class="dropdown" :data-qa-id="`${insideName} dropdown`">
            <div class="dropdownListHeadWrapper" :data-qa-id="`${insideName} dropdownListHeadWrapper`">
                <div class="dropdownInsideNameDiv" :data-qa-id="`${insideName} dropdownInsideNameDiv`">
                <MdTypography tag="span" :variant="'body1--medium'" :color="'spirits--900'" :data-qa-id="`${insideName}`">{{ insideName }}</MdTypography>
                    <span :class="[selectedItems.length == 0 ? 'disabledReset' : 'enabledReset', 'iconWrap']" :data-qa-id="`${insideName} iconWrap`" @click="resetDropdown">
                        <MdIconReload v-bind="{size:'sm',color:'spirits--600'}" slot="icon-start" :data-qa-id="`${insideName} icon`"></MdIconReload>
                        <MdTypography :variant="'micro1--medium'" :color="'spirits--700'" :data-qa-id="`${insideName} reset`">Reset</MdTypography>
                    </span>
            </div>
            <div class="dropdownOptions" :class="[showSelectionCountGlyphs ? 'heightChange' : '']" :data-qa-id="`${insideName} dropdownOptions`">
                <div class="option" v-for="option in options" :key="option" :class="[isSelectedOption(option) ? 'selected' : '']" :data-qa-id="`${insideName} option`">
                    <input type="checkbox" :checked="isSelected(option)" @change="toggleOption(option, $event)"
                        :value="option.name ? option.name : option" :id="option.name ? option.name : option" :data-qa-id="`${insideName} dropdownOptionsInput`"/>
                    <label :for="option.name ? option.name : option" :data-qa-id="`${insideName} dropdownOptionsLabel`">
                        <MdTypography :variant="'body2--medium'" :color="'spirits--900'">{{ option.name ? option.name : option }}</MdTypography>
                        <MdTypography v-if="option.subTitle" :variant="'body2--regular'" tag="span" :color="'spirits--700'" :data-qa-id="`${insideName} dropdownOptionSubTitle`">{{ option.subTitle }}</MdTypography>
                    </label>
                </div>
            </div>
            </div>
            <div class="dropdownActions" :data-qa-id="`${insideName} dropdownActions`">
                <div class="dropdownApply" v-if="cancel" :data-qa-id="`${insideName} cancel`">
                    <MdButton color="lightgrey" :data-qa-id="`${insideName} cancelbtn`" @click="cancelDropdown" :disabled="!enabledBtn">
                        {{ $t('pages.inventory_ingestion_hub.multi-select-dropdown.cancel') }}
                    </MdButton>
                </div>
                <div class="dropdownApply" v-if="showApply" :data-qa-id="`${insideName} apply`">
                    <MdButton @click="applyFoundriesSelection" :disabled="!enabledBtn" :data-qa-id="`${insideName} applybtn`">
                        {{ $t('pages.inventory_ingestion_hub.multi-select-dropdown.apply') }}
                    </MdButton>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { ref, watch, onMounted, onUnmounted, nextTick, computed } from 'vue';
import DropdownArrow from './assets/dropdown-arrow';
import ResetArrow from './assets/reset-arrow';
import { useStore } from 'vuex'
import { MdTypography, MdIconArrowCaret, MdButton, MdIconReload } from '@antiqua-dls/vue-components';
import { NUMBER_CIRCLE_GLYPH } from "../../../utils/constants/common"

export default {
    props: {
        name: {
            type: String,
            default: 'Select'
        },
        insideName: {
            type: String,
            default: 'Name'
        },
        options: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: Array,
            default: () => [],
        },
        disabledOptions: {
            type: Array,
            default: () => [],
        },
        customClass: {
            type: String,
            default: '',
        },
        showApply: {
            type: Boolean,
            default: false
        },
        cancel: {
            type: Boolean,
            default: false
        },
        componentName: {
            type: String,
            default: 'earning-reports'
        },
        showSelectionCountGlyphs: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:modelValue', 'openDropdown'],
    components: {
        DropdownArrow,
        ResetArrow,
        MdTypography,
        MdIconArrowCaret,
        MdButton,
        MdIconReload
    },
    setup(props, { emit }) {
        const selectedItems = ref([]);
        const isDropdownOpen = ref(false);
        const dropdownContainer = ref(null);
        const enabledBtn = ref(false);
        const previousSelected = ref([])
        const labelText = ref(null)
        const store = useStore()

        const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
            previousSelected.value = selectedItems.value
            emit('openDropdown', isDropdownOpen.value);
            nextTick(() => {
                if (selectedItems.value.length === 0) {
                    previousSelected.value = []
                    const dropdownMenus = document.querySelectorAll('.dropdownOptions')
                    dropdownMenus.forEach(dropdown => dropdown.scrollTo(0, 0))
                } else {
                    setTimeout(()=>{
                        const checkedCheckboxes = document.querySelectorAll('.dropdownOptions .option.selected');
                    if (checkedCheckboxes?.length > 0) {
                        checkedCheckboxes[0].scrollIntoView({ behavior: 'smooth', block: 'end' });
                    }
                    }, 0)
                }
                if (previousSelected.value.length === 0) {
                    enabledBtn.value = false
                } else {
                    enabledBtn.value = true
                }
            })
        }

        const isSelectedOption = (option) => {
            return previousSelected.value.some((item) => {
                if (item.name && option.name && item.name === option.name) {
                    return true;
                }

                return item === option;
            });
        };
       
        const toggleOption = (option, e) => {
            if (e.target.checked) {
                previousSelected.value = [...previousSelected.value, option];
            } else if (typeof option === 'object') {
                previousSelected.value = previousSelected.value.filter(p => p.name !== option.name)
            } else {
                previousSelected.value = previousSelected.value.filter(p => p !== option)
            }

            if (previousSelected.value.length > 0 || selectedItems.value.length > 0) {
                enabledBtn.value = true
            } else {
                enabledBtn.value = false
            }
            
            if (!props.showApply) {
                isDropdownOpen.value = false
                emit('update:modelValue', previousSelected.value);
            }
        }
        const applyFoundriesSelection = () => {
            isDropdownOpen.value = false
            selectedItems.value = [...new Set(previousSelected.value)]
            emit('update:modelValue', selectedItems.value);
            emit('openDropdown', isDropdownOpen.value); 
        }

        const resetDropdown = () => {
            previousSelected.value = [];
            selectedItems.value = [];
            isDropdownOpen.value = false;
            enabledBtn.value = false;
            emit('update:modelValue', selectedItems.value);  
            emit('openDropdown', isDropdownOpen.value); 
        }

        const cancelDropdown = () => {
            isDropdownOpen.value = false
            previousSelected.value = selectedItems.value
            emit('openDropdown', isDropdownOpen.value);
        }

        const isSelected = (option) => {
            return selectedItems.value.some((item) => {
                if (item.name && option.name && item.name === option.name) {
                    return true;
                }

                return item === option;
            });
        };

        const handleClickOutside = (event) => {
            if (dropdownContainer.value && !dropdownContainer.value.contains(event.target)) {
                isDropdownOpen.value = false;
                emit('openDropdown', isDropdownOpen.value);
            }
        };

        onMounted(() => {
            window.addEventListener('click', handleClickOutside);
            getLabelText()
        });

        onUnmounted(() => {
            window.removeEventListener('click', handleClickOutside);
        });

        // Watch for changes in the modelValue prop and update previousSelected accordingly
        watch(
            () => props.modelValue,
            (newValue) => {
                previousSelected.value = [...newValue];
            }
        );
        
        const getLabelText = () => {
            if (selectedItems.value.length === 0 || props.showSelectionCountGlyphs) {
                labelText.value = props.name
            }
            if (!props.showSelectionCountGlyphs) {
                if (selectedItems.value.length === 1) {
                    labelText.value = selectedItems.value[0].name || selectedItems.value[0]
                }

                if (selectedItems.value.length > 1 && props.name === "All foundries") {
                    labelText.value = `${selectedItems.value.length} foundries`
                }

                if (selectedItems.value.length > 1 && props.name === "All sources") {
                    labelText.value = `${selectedItems.value.length} sources`
                }
            }

        }

        watch(
            () => selectedItems.value,
            (newValue) => {
                getLabelText()
            },
            { deep: true }
        )

        onMounted(() => {
            const getViewedFromReportBtn = computed(() => store.getters['dashboard/getViewedFromReportBtn']);
            const sessionFoundryId = computed(() => store.getters['profile/sessionFoundryId']);
            const sessionFoundryName = computed(()=> store.getters['profile/sessionFoundryName'])
            if(getViewedFromReportBtn.value && props.name=='All foundries') {
                if (sessionFoundryId.value) {
                    const sessionFoundryObj = {
                        id: sessionFoundryId,
                        value: sessionFoundryId,
                        name: sessionFoundryName,
                        label: sessionFoundryName
                    }
                    selectedItems.value = [sessionFoundryObj]
                }
            }

        })

        return {
            labelText,
            isSelectedOption,
            getLabelText,
            previousSelected,
            enabledBtn,
            selectedItems,
            isDropdownOpen,
            dropdownContainer,
            toggleDropdown,
            resetDropdown,
            toggleOption,
            isSelected,
            cancelDropdown,
            applyFoundriesSelection,
            NUMBER_CIRCLE_GLYPH
        };
    },
};
</script>
  
<style scoped lang="scss">
@import 'mpl-css/lib/assets/global/functions/index';
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/mfpfonts/fonts';
@import 'mpl-css/lib/assets/global/variables/breakpoints.scss';

.greyBack {
    background-color: #F9FAFB;
}

.custom-multiselect {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;

    &:hover {
        background-color: #F9FAFB;
    }

    .selected-values {
        display: flex;
        gap: 0.5rem;
        align-items: center;
        cursor: pointer;
        text-wrap: nowrap;
        height: 100%;
        width: 100%;
        justify-content: center;

        @media screen and (min-width: map-get($breakpoints, 'tab')) and (max-width: map-get($breakpoints, 'l')) {
            width: 100%;
        }
        .labelCircle {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            justify-content: flex-start;
            .labelText {
            @media screen and (max-width: map-get($breakpoints, 'm')) {
                text-overflow: ellipsis;
                width: 150px;
                overflow: hidden;
            }

            @media screen and (max-width: map-get($breakpoints, 's')) {
                text-overflow: ellipsis;
                width: 100px;
                overflow: hidden;
            }

            @media screen and (max-width: map-get($breakpoints, 'tab')) {
                text-overflow: ellipsis;
                width: 80px;
                overflow: hidden;
            }
        }
        .circle {
            @extend .mfp-HelveticaNowMTText-Regular-13;
            height: 16px;
            width: 16px;
            background-color: map-get($colors, 'blue-duck--500');
            color: map-get($colors, 'white');
            border-radius: 50%;
            display: inline-flex;
            text-align: center;
            justify-content: center;
            align-items: center;
        }

        }

        .dropdownArrow {
            transition: all 1s;
            @media screen and (min-width: map-get($breakpoints, 'tab')) and (max-width: map-get($breakpoints, 'l')) { 
                margin-left: auto;
            }

            .rotateIcon {
                transform: rotate(180deg);
            }
        }
    }
}

.dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #fff;
    border: 1px solid map-get($colors, 'spirits-300');
    box-shadow: 0px 112px 228px 0px #3749511F;
    border-radius: 8px;
    width: rem(255px);

    .dropdownListHeadWrapper {
        display: flex;
        justify-content: center;
        flex-direction: column;
        gap: rem(4);
        padding: rem(8px);
        .dropdownInsideNameDiv {
            padding: rem(16px);
            display: flex;
            align-items: center;
            gap: rem(16);
            position: relative;

        .disabledReset {
            pointer-events: none;
        }

        .enabledReset {
            cursor: pointer;
        }

        .iconWrap {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: rem(8);
            margin-left: auto;
        }

    }

    .dropdownOptions {
        overflow: scroll;
        overflow-x: hidden;
        border-radius: 10px;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: rem(4);
        max-height: 10.5rem;

        .option {
            @extend .mfp-HelveticaNowMTText-Regular-13;
            padding: 0 0 0 16px;
            color: map-get($colors, 'spirits-700');
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            gap: rem(8);

            input[type='checkbox'] {
                min-height: 0;
                cursor: pointer;
                margin-top: rem(14);

                &:disabled {
                    opacity: 0.5;
                }
            }

            label{
                width: 100%;
                padding: 12px 16px 12px 0;
                cursor: pointer;
                display: flex;
                flex-direction: column;
            }
        }


        &::-webkit-scrollbar {
            width: rem(8);
        }

        &::-webkit-scrollbar-track {
            background-color: transparent;
            margin: rem(5);
        }

        &::-webkit-scrollbar-thumb {
            background-color: #DBDFE5;
            border-radius: 4px;

            &:hover {
                background-color: #555;
            }
        }
    }

    }


        .dropdownActions {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 16px 24px;
            gap: 8px;
            border-top: 1px solid map-get($colors, 'spirits-300');

                               
                .dropdownApplyBtn {
                    @extend .mfp-HelveticaNowMTMicro-Medium-11;
                    border: 1px solid map-get($colors, 'blueduck-500');
                    background-color: map-get($colors, 'blueduck-500');
                    border-radius: 8px;
                    padding: rem(8) rem(12);
                    color: map-get($colors, 'white');
                    cursor: pointer;
                    width: rem(60);
                    height: rem(32);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                } 
                
                .dropdownCancelBtn {
                    color: map-get($colors, 'spirits--900');
                    background-color: map-get($colors, 'spirits-200');
                    border-color: map-get($colors, 'spirits-200');
                }
                .disabledBtn {
                    pointer-events: none;
                    opacity: 0.4;
                }
        }
}
</style>
